<template>
  <div class="bg-canvas">
      <NuxtLayout>
          <template #body_page>
              <Banner :title="`Privacy Policy`"/>
              <div class='maxw-890 ma-0-auto pl-25 pr-25'>
                  <table class='mb-60 wp-100'>
                      <tr>
                          <td class='minw-192'>
                              Designer Journeys
                          </td>
                          <td>
                              means Designer Journeys Pty Ltd, a private company trading as Designer Journeys.
                          </td>
                      </tr>
                      <tr>
                          <td>
                              GDPR
                          </td>
                          <td>
                              means the General Data Protection Regulation.
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Responsible Person
                          </td>
                          <td>
                              means Mr Matt McCann, Chief Executive Officer and Managing Director.
                          </td>
                      </tr>
                      <tr>
                          <td>
                              Register of Systems
                          </td>
                          <td>
                              means a register of all systems or contexts in which personal data is processed by Designer Journeys.
                          </td>
                      </tr>
                  </table>
                  <ol>
                      <li class='pb-15'>
                          <p class='fw-900 fs-28 lh-28 mb-33'>1. Introduction</p>
                          <ol>
                              <li>
                                  <div class='flex'>
                                      <span>1.1</span>
                                      <div>We are committed to safeguarding the privacy of our website visitors; in this policy we explain how we will treat your personal information.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                                      <span>1.2</span>
                                      <div>
                                          We will ask you to consent to our use of cookies in accordance with the terms of this policy when you first visit our website. / By using our website and agreeing to this policy, you consent to our use of cookies in accordance with the terms of this policy.
                                      </div>
                                  </div>
                              </li>
                          </ol>
                      </li>
                      <li class='pb-15'>
                          <p class='fw-900 fs-28 lh-28 mb-33'>2. Credit</p>
                          <ol>
                              <li>
                                  <div class='flex'>
                                      <span>2.1</span>
                                      <div>
                                          This document was created using a template from <a href='https://seqlegal.com/' target="_blank" rel="noreferrer noopener"><small class='black underline fs-16'>SEQ Legal</small></a>.
                                      </div>
                                  </div>
                              </li>
                          </ol>
                      </li>
                      <li class='pb-15'>
                          <p class='fw-900 fs-28 lh-28 mb-33'>2. Collecting personal information
                          </p>
                          <ol>
                              <li>
                                  <div class='flex'>
                                      <span>3.1</span>
                                      <div>
                                          We may collect, store and use the following kinds of personal information:
                                      </div>
                                  </div>
                                  <ol class='pl-10'>
                                      <li class='flex'>
                                          <span>a.</span>
                                          <div>
                                              information about your computer and about your visits to and use of this website (including your IP address, geographical location, browser type and version, operating system, referral source, length of visit, page views and website navigation paths);
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>b.</span>
                                          <div>
                                              information that you provide to us when registering with our website (including your email address);
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>c.</span>
                                          <div>
                                              information that you provide when completing your profile on our website (including your name, pictures, gender and date of birth);
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>d.</span>
                                          <div>
                                              information that you provide to us for the purpose of subscribing to our email notifications and/or newsletters (including your name and email address);
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>e.</span>
                                          <div>
                                              information that you provide to us when using the services on our website, or that is generated in the course of the use of those services (including the timing, frequency and pattern of service use);
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>f.</span>
                                          <div>
                                              information relating to any purchases you make of our goods and/or services or any other transactions that you enter into through our website (including your name, address, telephone number, email address and card details);
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>g.</span>
                                          <div>
                                              information that you post to our website for publication on the internet (including your user name, your profile pictures and the content of your posts);
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>h.</span>
                                          <div>
                                              information contained in or relating to any communication that you send to us or send through our website (including the communication content and metadata associated with the communication).
                                          </div>
                                      </li>
                                  </ol>
                              </li>
                              <li>
                                  <div class='flex'>
                  <span>
                    3.2
                  </span>
                                      <div>
                                          Before you disclose to us the personal information of another person, you must obtain that person's consent to both the disclosure and the processing of that personal information in accordance with this policy.
                                      </div>
                                  </div>
                              </li>
                          </ol>
                      </li>
                      <li class='pb-15'>
                          <p class='fw-900 fs-28 lh-28 mb-33'>4. Using personal information</p>
                          <ol>
                              <li>
                                  <div class='flex'>
                                      <span>4.1</span>
                                      <div>
                                          Personal information submitted to us through our website will be used for the purposes specified in this policy or on the relevant pages of the website.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                                      <span>4.2</span>
                                      <div>
                                          We may use your personal information to:
                                      </div>
                                  </div>
                                  <ol class='pl-10'>
                                      <li class='flex'>
                                          <span>a.</span>
                                          <div>
                                              administer our website and business;
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>b.</span>
                                          <div>
                                              personalise our website for you;
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>c.</span>
                                          <div>
                                              enable your use of the services available on our website;
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>d.</span>
                                          <div>
                                              supply to you services purchased through our website;
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>e.</span>
                                          <div>
                                              send statements, invoices and payment reminders to you, and collect payments from you;
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>f.</span>
                                          <div>
                                              send you email notifications that you have specifically requested;
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>g.</span>
                                          <div>
                                              send you our email newsletter, if you have requested it (you can inform us at any time if you no longer require the newsletter);
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>h.</span>
                                          <div>
                                              send you marketing communications relating to our business which we think may be of interest to you, by post or, where you have specifically agreed to this, by email or similar technology (you can inform us at any time if you no longer require marketing communications);
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>i.</span>
                                          <div>
                                              deal with enquiries and complaints made by or about you relating to our website;
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>j.</span>
                                          <div>
                                              keep our website secure and prevent fraud;
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>k.</span>
                                          <div>
                                              verify compliance with the terms and conditions governing the use of our website (including monitoring private messages sent through our website private messaging service)
                                          </div>
                                      </li>
                                  </ol>

                              </li>
                              <li>
                                  <div class='flex'>
                  <span>
                    4.3
                  </span>
                                      <div>
                                          If you submit personal information for publication on our website, we will publish and otherwise use that information in accordance with the licence you grant to us.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                  <span>
                    4.4
                  </span>
                                      <div>
                                          Your privacy settings can be used to limit the publication of your information on our website, and can be adjusted using privacy controls on the website.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                  <span>
                    4.5
                  </span>
                                      <div>
                                          We will not, without your express consent, supply your personal information to any third party for the purpose of their or any other third party's direct marketing.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                  <span>
                    4.6
                  </span>
                                      <div>
                                          All our website financial transactions are handled through our payment services providers:
                                          <a href='https://pinpayments.com/' target="_blank" rel="noreferrer noopener"><small class='fs-16 underline black'>Pin Payments</small></a>,
                                          <a href='https://www.paypal.com/vn/home' target="_blank" rel="noreferrer noopener"><small class='fs-16 underline black'>PayPal</small></a>,
                                          <a href='https://www.nab.com.au/' target="_blank" rel="noreferrer noopener"><small class='fs-16 underline black'>NAB Bank</small></a>,
                                          <a href='https://www.hyperwallet.com/' target="_blank" rel="noreferrer noopener"><small class='fs-16 underline black'>Hyperwallet</small></a> and
                                          <a href='https://www.airwallex.com/' target="_blank" rel="noreferrer noopener"><small class='fs-16 underline black'>Airwallex</small></a>. You can review the provider's respective privacy policies on their websites. We will share information with our payment services providers only to the extent necessary for the purposes of processing payments you make via our website, refunding such payments and dealing with complaints and queries relating to such payments and refunds.
                                      </div>
                                  </div>
                              </li>
                          </ol>
                      </li>
                      <li class='pb-15'>
                          <p class='fw-900 fs-28 lh-28 mb-33'>5. Disclosing personal information
                          </p>
                          <ol>
                              <li>
                                  <div class='flex'>
                                      <span>5.1</span>
                                      <div>
                                          We may disclose your personal information to any of our employees, officers, insurers or professional advisers, insofar as reasonably necessary for the purposes set out in this policy.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                                      <span>5.2</span>
                                      <div>
                                          We may disclose your personal information:
                                      </div>
                                  </div>
                                  <ol class='pl-10'>
                                      <li class='flex'>
                                          <span>a.</span>
                                          <div>
                                              to the extent that we are required to do so by law;
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>b.</span>
                                          <div>
                                              in connection with any ongoing or prospective legal proceedings;
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>c.</span>
                                          <div>
                                              in order to establish, exercise or defend our legal rights (including providing information to others for the purposes of fraud prevention and reducing credit risk);
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>d.</span>
                                          <div>
                                              to any person who we reasonably believe may apply to a court or other competent authority for disclosure of that personal information where, in our reasonable opinion, such court or authority would be reasonably likely to order disclosure of that personal information.
                                          </div>
                                      </li>
                                  </ol>
                              </li>
                              <li>
                                  <div class='flex'>
                                      <span>5.3</span>
                                      <div>
                                          Except as provided in this policy, we will not provide your personal information to third parties.
                                      </div>
                                  </div>
                              </li>
                          </ol>
                      </li>
                      <li class='pb-15'>
                          <p class='fw-900 fs-28 lh-28 mb-33'>6. International data transfers
                          </p>
                          <ol>
                              <li>
                                  <div class='flex'>
                  <span>
                    6.1
                  </span>
                                      <div>
                                          Information that we collect may be stored and processed in and transferred between any of the countries in which we operate in order to enable us to use the information in accordance with this policy.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                  <span>
                    6.2
                  </span>
                                      <div>
                                          Personal information that you publish on our website or submit for publication on our website may be available, via the internet, around the world. We cannot prevent the use or misuse of such information by others.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                  <span>
                    6.3
                  </span>
                                      <div>
                                          You expressly agree to the transfers of personal information described in this Section 6.
                                      </div>
                                  </div>
                              </li>
                          </ol>
                      </li>
                      <li class='pb-15'>
                          <p class='fw-900 fs-28 lh-28 mb-33'>7. Retaining personal information
                          </p>
                          <ol>
                              <li>
                                  <div class='flex'>
                  <span>
                    7.1
                  </span>
                                      <div>
                                          This Section 7 sets out our data retention policies and procedure, which are designed to help ensure that we comply with our legal obligations in relation to the retention and deletion of personal information.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                  <span>
                    7.2
                  </span>
                                      <div>
                                          Personal information that we process for any purpose or purposes shall not be kept for longer than is necessary for that purpose or those purposes.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                  <span>
                    7.3
                  </span>
                                      <div>
                                          Notwithstanding the other provisions of this Section 7, we will retain documents (including electronic documents) containing personal data:
                                      </div>
                                  </div>
                                  <ol class='pl-10'>
                                      <li class='flex'>
                                          <span>a.</span>
                                          <div>
                                              to the extent that we are required to do so by law;
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>b.</span>
                                          <div>
                                              if we believe that the documents may be relevant to any ongoing or prospective legal proceedings; and
                                          </div>
                                      </li>
                                      <li class='flex'>
                                          <span>c.</span>
                                          <div>
                                              in order to establish, exercise or defend our legal rights (including providing information to others for the purposes of fraud prevention and reducing credit risk).
                                          </div>
                                      </li>
                                  </ol>
                              </li>
                          </ol>
                      </li>
                      <li class='pb-15'>
                          <p class='fw-900 fs-28 lh-28 mb-33'>8. Security of personal information
                          </p>
                          <ol>
                              <li>
                                  <div class='flex'>
                                      <span>8.1</span>
                                      <div>
                                          We will take reasonable technical and organisational precautions to prevent the loss, misuse or alteration of your personal information.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                                      <span>8.2</span>
                                      <div>
                                          We will store all the personal information you provide on our secure (password- and firewall-protected) servers.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                                      <span>8.3</span>
                                      <div>
                                          All electronic financial transactions entered into through our website will be protected by encryption technology.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                                      <span>8.4</span>
                                      <div>
                                          You acknowledge that the transmission of information over the internet is inherently insecure, and we cannot guarantee the security of data sent over the internet.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                                      <span>8.5</span>
                                      <div>
                                          You are responsible for keeping the password you use for accessing our website confidential; we will not ask you for your password (except when you log in to our website).
                                      </div>
                                  </div>
                              </li>
                          </ol>
                      </li>
                      <li class='pb-15'>
                          <p class='fw-900 fs-28 lh-28 mb-33'>9. Amendments
                          </p>
                          <ol>
                              <li>
                                  <div class='flex'>
                  <span>
                    9.1
                  </span>
                                      <div>
                                          We may update this policy from time to time by publishing a new version on our website.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                  <span>
                    9.2
                  </span>
                                      <div>
                                          You should check this page occasionally to ensure you are happy with any changes to this policy.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                  <span>
                    9.3
                  </span>
                                      <div>
                                          We may notify you of changes to this policy by email.
                                      </div>
                                  </div>
                              </li>
                          </ol>
                      </li>
                      <li class='pb-15'>
                          <p class='fw-900 fs-28 lh-28 mb-33'>10. Your rights
                          </p>
                          <ol>
                              <li>
                                  <div class='flex'>
                                      <span>10.1</span>
                                      <div>
                                          You may instruct us to provide you with any personal information we hold about you; provision of such information will be subject to:
                                      </div>
                                  </div>
                                  <ol class='pl-10'>
                                      <li class='flex'>
                                          <span>a.</span>
                                          <div>
                                              the supply of appropriate evidence of your identity (for this purpose, we will usually accept a photocopy of your passport certified by a solicitor).
                                          </div>
                                      </li>
                                  </ol>
                              </li>
                              <li>
                                  <div class='flex'>
                                      <span>10.2</span>
                                      <div>
                                          We may withhold personal information that you request to the extent permitted by law.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                                      <span>10.3</span>
                                      <div>
                                          You may instruct us at any time not to process your personal information for marketing purposes.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                                      <span>10.4</span>
                                      <div>
                                          In practice, you will usually either expressly agree in advance to our use of your personal information for marketing purposes, or we will provide you with an opportunity to opt out of the use of your personal information for marketing purposes.
                                      </div>
                                  </div>
                              </li>
                          </ol>
                      </li>
                      <li class='pb-15'>
                          <p class='fw-900 fs-28 lh-28 mb-33'>11. Third party websites
                          </p>
                          <ol>
                              <li>
                                  <div class='flex'>
                                      <span>11.1</span>
                                      <div>
                                          Our website includes hyperlinks to, and details of, third party websites.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                                      <span>11.2</span>
                                      <div>
                                          We have no control over, and are not responsible for, the privacy policies and practices of third parties.
                                      </div>
                                  </div>
                              </li>
                          </ol>
                      </li>
                      <li class='pb-15'>
                          <p class='fw-900 fs-28 lh-28 mb-33'>12. Updating information
                          </p>
                          <ol>
                              <li>
                                  <div class='flex'>
                                      <span>12.1</span>
                                      <div>
                                          Please let us know if the personal information that we hold about you needs to be corrected or updated.
                                      </div>
                                  </div>
                              </li>
                          </ol>
                      </li>
                      <li class='pb-15'>
                          <p class='fw-900 fs-28 lh-28 mb-33'>13. Cookies
                          </p>
                          <ol>
                              <li>
                                  <div class='flex'>
                  <span>
                    13.1
                  </span>
                                      <div>
                                          Our website uses cookies.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                  <span>
                    13.2
                  </span>
                                      <div>
                                          A cookie is a file containing an identifier (a string of letters and numbers) that is sent by a web server to a web browser and is stored by the browser. The identifier is then sent back to the server each time the browser requests a page from the server.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                                      <span>13.3</span>
                                      <div>
                                          Cookies may be either "persistent" cookies or "session" cookies: a persistent cookie will be stored by a web browser and will remain valid until its set expiry date, unless deleted by the user before the expiry date; a session cookie, on the other hand, will expire at the end of the user session, when the web browser is closed.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                  <span>
                    13.4
                  </span>
                                      <div>
                                          Cookies do not typically contain any information that personally identifies a user, but personal information that we store about you may be linked to the information stored in and obtained from cookies.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                  <span>
                    13.5
                  </span>
                                      <div>
                                          We use both session and persistent cookies on our website.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                  <span>
                    13.6
                  </span>
                                      <div>
                                          The names of the cookies that we use on our website, and the purposes for which they are used, are set out below:
                                      </div>
                                  </div>
                                  <ol class='pl-10'>
                                      <li class='flex'>
                    <span>
                      a.
                    </span>
                                          <div>
                                              we use cookies on the folder cookies on our website to recognise a computer when a user visits the website, track users as they navigate the website, enable the use of a shopping cart on the website, improve the website's usability, analyse the use of the website, administer the website, prevent fraud and improve the security of the website and personalise the website for each user
                                          </div>
                                      </li>
                                  </ol>
                              </li>
                              <li>
                                  <div class='flex'>
                  <span>
                    13.7
                  </span>
                                      <div>
                                          Most browsers allow you to refuse to accept cookies; for example:
                                      </div>
                                  </div>
                                  <ol class='pl-10'>
                                      <li class='flex'>
                    <span>
                      a.
                    </span>
                                          <div>
                                              in Internet Explorer (version 11) you can block cookies using the cookie handling override settings available by clicking "Tools", "Internet Options", "Privacy" and then "Advanced";
                                          </div>
                                      </li>
                                      <li class='flex'>
                    <span>
                      b.
                    </span>
                                          <div>
                                              in Firefox (version 36) you can block all cookies by clicking "Tools", "Options", "Privacy", selecting "Use custom settings for history" from the drop-down menu, and unticking "Accept cookies from sites"; and
                                          </div>
                                      </li>
                                      <li class='flex'>
                    <span>
                      c.
                    </span>
                                          <div>
                                              in Chrome (version 41), you can block all cookies by accessing the "Customise and control" menu, and clicking "Settings", "Show advanced settings" and "Content settings", and then selecting "Block sites from setting any data" under the "Cookies" heading.
                                          </div>
                                      </li>
                                  </ol>
                              </li>
                              <li>
                                  <div class='flex'>
                  <span>
                    13.8
                  </span>
                                      <div>
                                          Blocking all cookies will have a negative impact upon the usability of many websites.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                  <span>
                    13.9
                  </span>
                                      <div>
                                          If you block cookies, you will not be able to use all the features on our website.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                  <span>
                    13.10
                  </span>
                                      <div>
                                          You can delete cookies already stored on your computer; for example:
                                      </div>
                                  </div>
                                  <ol class='pl-10'>
                                      <li class='flex'>
                                          <span>a.</span>
                                          <div>
                                              in Internet Explorer (version 11), you must manually delete cookie files (you can find instructions for doing so here);
                                          </div>
                                      </li>
                                      <li class='flex'>
                    <span>
                      b.
                    </span>
                                          <div>
                                              in Firefox (version 36), you can delete cookies by clicking "Tools", "Options" and "Privacy", then selecting "Use custom settings for history" from the drop-down menu, clicking "Show Cookies", and then clicking "Remove All Cookies"; and
                                          </div>
                                      </li>
                                      <li class='flex'>
                    <span>
                      c.
                    </span>
                                          <div>
                                              in Chrome (version 41), you can delete all cookies by accessing the "Customise and control" menu, and clicking "Settings", "Show advanced settings" and "Clear browsing data", and then selecting "Cookies and other site and plug-in data" before clicking "Clear browsing data".
                                          </div>
                                      </li>
                                  </ol>
                              </li>
                              <li>
                                  <div class='flex'>
                                      <span>13.11</span>
                                      <div>
                                          Deleting cookies will have a negative impact on the usability of many websites.
                                      </div>
                                  </div>
                              </li>

                          </ol>
                      </li>
                      <li class='pb-15'>
                          <p class='fw-900 fs-28 lh-28 mb-33'>14. Collecting personal information
                          </p>
                          <ol>
                              <li>

                                  <div class='flex'>
                                      <span>14.1</span>
                                      <div>
                                          This website is owned and operated by Designer Journeys Pty Ltd.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                  <span>
                    14.2
                  </span>
                                      <div>
                                          We are registered in Australia under the Australian Business Number ABN <a href="https://abr.business.gov.au/ABN/View/47615829671" target="_blank" rel="noreferrer noopener"><small class='underline fs-16 black'>47 615 829 671</small></a> , and our registered office is at Level 7, 485 Bourke Street, Melbourne, Victoria, Australia, 3000.
                                      </div>
                                  </div>
                              </li>
                              <li>
                                  <div class='flex'>
                  <span>
                    14.3
                  </span>
                                      <div>
                                          You can contact us by writing to the business address given above, by using our website contact form, by email to
                                          <a href="mailto:info@designerjourneys.com" target="_blank" rel="noreferrer noopener"><small class='underline fs-16 black'>info@designerjourneys.com</small></a> or by telephone on +61 3 9926 0500.
                                      </div>
                                  </div>
                              </li>
                          </ol>
                      </li>
                  </ol>
              </div>
          </template>
      </NuxtLayout>
  </div>
</template>

<script>
import { debounceAmplitudeScriptTracking } from '~/mixins/amplitude'
// import DefaultLayout from '../../components/globals/layout/DefaultLayout'
import Banner from '~/components/sections/SectionBannerTitle/BannerTitle'
// import { useHead } from '@vueuse/head'
import { onMounted/*,computed, ref*/ } from 'vue'
// import Metadata from '~/assets/meta_data.json'

export default {
  name: 'privacy-policy',
  components: {
    /*DefaultLayout,*/
    Banner
  },
  setup() {
    // const route = useRoute()
    // const runtime = useRuntimeConfig()
    // const metaData = ref(Metadata);
    // const canonical = runtime.public.publicDomain + route.path

    onMounted(() => {
      debounceAmplitudeScriptTracking("View Privacy Policy")
    })

    // useHead({
    //   title: computed(() => {
    //     const title = metaData.value.privacy_policy.title
    //     return title
    //   }),
    //
    //   meta: computed(() => {
    //     const title = metaData.value.privacy_policy.title
    //     const description = metaData.value.privacy_policy.description
    //     return [
    //       {
    //         name: `title`,
    //         content: title,
    //       },
    //       {
    //         name: `description`,
    //         content: description,
    //       }
    //     ]
    //   }),
    //   link: computed(() => {
    //     return [
    //       { rel: 'canonical', href: `${canonical}`}
    //     ]
    //   }),
    // })
  }
}
</script>
<style scoped lang="scss">
table {
  border-collapse: collapse;
}
tr td {
  border: 1px solid #000;
  font-size: 16px;
  line-height: 24px;
  padding: 8px 12px;
}
ol {
  li {
    margin-top: 15px;
    span {
      font-family: $font-family-base;
      font-weight: 700;
      color: $link; // v2 — numbered-list markers to brand green (was off-brand light $blue-branding)
      margin-right: 12px;
      display: inline-block;
      font-size: 20px;
      line-height: 28px;
    }
    div {
      line-height: 24px;
      font-size: 16px;
    }
    .flex div {
      padding-top: 2px;
    }
  }
}
</style>
